import { useRouter } from 'next/router';
import React from 'react';

import CTA from '../../components/CTA';
import CustomHead from '../../components/CustomHead';
import Footer from '../../components/FooterNew';
import Header from '../../components/HeaderNew';
import {
  SectionContainer,
  SectionHeading,
} from '../../components/landing/sectionComponents';
import useGa from '../../hooks/useGa';

function BlogFormat() {
  const router = useRouter();

  return (
    <>
      <CustomHead
        meta={{
          title: `PopSQL is the Premier Business Intelligence vendor for Segment's Startup Program`,
        }}
        openGraph={{
          url: `${process.env.NEXT_PUBLIC_WEB_HOST}${router.asPath}`,
        }}
      />
      <main>
        <Header />
        <SectionContainer styles={{ paddingTop: '86px', paddingBottom: '0' }}>
          <SectionHeading
            text={
              "PopSQL is the Premier Business Intelligence vendor for Segment's Startup Program"
            }
            moreStyles={{ maxWidth: '800px' }}
          />

          <img
            className="my-16"
            width="340"
            src={`${process.env.NEXT_PUBLIC_ASSET_HOST}/static/external-logos/segment.svg`}
            alt="github backpack logo"
          />

          <div
            style={{ maxWidth: '800px' }}
            className="w-full font-inter text-lg leading-relaxed text-gray-500 mx-auto my-6 md:my-10 px-16"
          >
            We've partnered with Segment to offer startups enrolled in their
            Startup Program our <a href="/pricing">Business</a> plan free for 12
            months. <br />
            <br />
            For eligibility requirements and access please email{' '}
            <a href="mailto:segment@popsql.com">segment@popsql.com</a>. If you
            have yet to register,{' '}
            <a href="https://airtable.com/shrLP3GSZnxt1WT2v?prefill_Partner%20Code=popsqlfriends">
              you can fill out an application
            </a>{' '}
            on Segment.
          </div>

          <div className="text-center mb-4">
            <a
              href={`${process.env.NEXT_PUBLIC_WEB_HOST}/users/sign_up`}
              onClick={useGa('Segment Startup', 'Hero')}
              className="inline-block bg-primary text-white font-inter font-semibold py-4 px-8 rounded-md hover:shadow-lg focus:shadow-lg focus:outline-none focus:opacity-80 transition duration-200 ease block text-center cursor-pointer leading-none shadow-sm"
            >
              Sign up
            </a>
          </div>
        </SectionContainer>

        <CTA />
      </main>
      <Footer />
    </>
  );
}

export default BlogFormat;
